const APP_ACTIONS = {
    DISPLAY_LOADER: 'DISPLAY_LOADER',
    HIDE_LOADER: 'HIDE_LOADER',
    ADD_ERROR: 'ADD_ERROR',

    ADD_PRODUCTS: 'ADD_PRODUCTS',
    APPEND_PRODUCTS: 'APPEND_PRODUCTS',
    ADD_PRODUCT: 'ADD_PRODUCT',
    ADD_PLACED_ORDER: 'ADD_PLACED_ORDER',
    DESTROY_PLACED_ORDER: 'DESTROY_PLACED_ORDER',
    ADD_PRODUCTS_FROM_ALL_STORES: 'ALL_PRODUCTS_FROM_ALL_STORES',

    ADD_ORDERS: 'ADD_ORDERS',
    ADD_ORDER: 'ADD_ORDER',

    ADD_ORDER_ERROR: 'ADD_ORDER_ERROR',
    COMPLETE_ORDER_ERROR: 'COMPLETE_ORDER_ERROR',
    COMPLETE_ORDER_ERROR_HIDE_DIALOG: 'COMPLETE_ORDER_ERROR_HIDE_DIALOG',

    ADD_PAYMENT_METHOD: 'ADD_PAYMENT_METHOD',
    ADD_REDSYS_PAYMENT_INFO: 'ADD_REDSYS_PAYMENT_INFO',
    ADD_REDSYS_PAYMENT_ERROR: 'ADD_REDSYS_PAYMENT_ERROR',

    ADD_TAXONS: 'ADD_TAXONS',
    ADD_KATAPULK_NAVIGATION: 'ADD_KATAPULK_NAVIGATION',
    ADD_SEARCH_TAXONS: 'ADD_SEARCH_TAXONS',

    ADD_STORES: 'ADD_STORES',
    ADD_STORES_BY_ZONE: 'ADD_STORES_BY_ZONE',
    ADD_STORES_GROUPED: 'ADD_STORES_GROUPED',
    SET_CURRENT_STORE: 'SET_CURRENT_STORE',

    CREATE_ORDER: 'CREATE_ORDER',
    UPDATE_ORDER: 'UPDATE_ORDER',
    ADD_PRODUCT_TO_CART: 'ADD_PRODUCT_TO_CART',
    ADDING_PRODUCT_TO_CART: 'ADDING_PRODUCT_TO_CART',
    ADDING_PRODUCT_TO_CART_TO_FIX: 'ADDING_PRODUCT_TO_CART_TO_FIX',
    REMOVING_PRODUCT_TO_CART: 'REMOVING_PRODUCT_TO_CART',
    DISABLING_ADD: 'DISABLING_ADD',
    DESTROY_ORDER: 'DESTROY_ORDER',
    COMPLETE_ORDER: 'COMPLETE_ORDER',
    REMOVE_LINE_ITEM: 'REMOVE_LINE_ITEM',
    REMOVE_DATA_EXTRA_ITEM: 'REMOVE_DATA_EXTRA_ITEM',
    UPDATE_LINE_ITEM: 'UPDATE_LINE_ITEM',
    VALIDATE_CREDIT_CARD: 'VALIDATE_CREDIT_CARD',

    ADD_COUNTRIES_SHIPPING: 'ADD_COUNTRIES_SHIPPING',
    ADD_COUNTRIES_BILLING: 'ADD_COUNTRIES_BILLING',

    SET_CURRENT_CHECKOUT_STEP: 'SET_CURRENT_CHECKOUT_STEP',
    CLEAR_CURRENT_CHECKOUT_STEP: 'CLEAR_CURRENT_CHECKOUT_STEP',

    SET_FETCHING_DATA: 'SET_FETCHING_DATA',

    SET_LOCALE: 'SET_LOCALE',
    SET_AVAILABLE_ZONES: 'SET_AVAILABLE_ZONES',
    SET_CURRENT_ZONE: 'SET_CURRENT_ZONE',

    SET_AVAILABLE_MUNICIPALITIES: 'SET_AVAILABLE_MUNICIPALITIES',
    SET_CURRENT_MUNICIPALITY: 'SET_CURRENT_MUNICIPALITY',
    SET_IS_MUNICIPALITY_PROMPT_MODAL_OPEN: 'SET_IS_MUNICIPALITY_PROMPT_MODAL_OPEN',

    LOGIN: 'LOGIN',
    LOGOUT: 'LOGOUT',
    USER: 'USER',
    REMOVE_USER: 'REMOVE_USER',
    ANONYMOUS_USER_AGE_VALID: 'ANONYMOUS_USER_AGE_VALID',

    SET_ACTIVE_CART: 'SET_ACTIVE_CART',
    SET_CONFIGS_ACTIVE_CART: 'SET_CONFIGS_ACTIVE_CART',
    UPDATE_MINUTES_TIME_LEFT_CART: 'UPDATE_MINUTES_TIME_LEFT_CART',
    UPDATE_SECONDS_TIME_LEFT_CART: 'UPDATE_SECONDS_TIME_LEFT_CART',
    SET_LAST_ALERT_TIME_LEFT_CART: 'SET_LAST_ALERT_TIME_LEFT_CART',
    SET_EXTRA_TIME_CHECKOUT: 'SET_EXTRA_TIME_CHECKOUT',

    SET_BACKGROUND_DISABLED: 'SET_BACKGROUND_DISABLED',
    SET_IS_FINAL_STEP_HAPPENING: 'SET_IS_FINAL_STEP_HAPPENING',

    SYNC_ORDER_FROM_STORAGE: 'SYNC_ORDER_FROM_STORAGE',

    CONFIG_SET_MULTI_COUNTRY_SHIPPING: 'CONFIG_SET_MULTI_COUNTRY_SHIPPING',
    SET_BACKEND_CONFIG: 'SET_BACKEND_CONFIG',

    ERRORS_LINE_ITEMS: 'ERRORS_LINE_ITEMS',
    CLEAR_ERRORS_LINE_ITEMS: 'CLEAR_ERRORS_LINE_ITEMS',

    UPDATE_WALLETS: 'UPDATE_WALLETS',
    CLEAR_WALLETS: 'CLEAR_WALLETS',
};

export default APP_ACTIONS;



/** WEBPACK FOOTER **
 ** ./src/constants/app-actions.js
 **/